import { render, staticRenderFns } from "./GridQuestion.vue?vue&type=template&id=05318dc0"
import script from "./GridQuestion.vue?vue&type=script&lang=js"
export * from "./GridQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports